<div class="report-model">



    <!-- <app-datatable-title [title]="'reports.unitTransactionsPrices'" [count]="unitTransactionCount"></app-datatable-title> -->
    <div class="report-model-header w-72">
        <div class="info">
            <h3>{{("reports.unitTransactionsPrices" | translate)}}</h3>
            <span class="totalTransaction">({{actualCount }} {{" "+("reports.actual_transactions_with"|translate)+" "}}
              {{ quoteCount }} {{" "+("reports.Quote" | translate)+" "}}{{("reports.And" | translate)+" "}}
              {{ auctionCount}} {{" "+("reports.Auction" | translate)}})</span>
        </div>
    </div>
    <!-- <app-residential-detail-table
     class="default-table-view"
        [tableName]="'unitTransaction'"
        [showLoader]="!unitTransactionLoading"
        [tableColumns]="unitTransactionPropertyColumns"
        [dataLength]="unitTransactionCount"
        [tableData]="unitTransactionData"
        [allowExcelDownload]="true"
        (pageEvent)="onPageEvent($event)"
        (sort)="sortData($event)"
        (excelDownload)="downloadExcel($event, 'ir_inventory_unit_transaction')"
        [dropDownOption] = "transactionType"
        (dropDownValue) = "selectionChange($event)"
        [downloadLoading]="reportPropertyDetailService.downloadLoading['b']">
    </app-residential-detail-table> -->
</div>
